import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApplicationService } from 'app/application/application.service';
import { GiftCardDetails, Application } from 'app/application/application';
import { ApiDataService } from '../api-data.service';
import { MerchantSetting } from '../../landing-pages/gift-card/gift-card';

@Component({
  selector: 'zest-how-to-redeem-card',
  templateUrl: './how-to-redeem-card.component.html',
  styleUrls: ['./how-to-redeem-card.component.scss']
})
export class HowToRedeemCardComponent implements OnInit {

  @Input() vouchers: GiftCardDetails[];

  s3BucketUrl = environment.s3BucketUrl;
  offlineMerchants: string[] = [];
  redeemSteps: any[];
  allSameMerchant = true;
  showMerchantLogo = true;
  application: Application;
  merchantSettings: MerchantSetting[];

  constructor(
    private applicationService: ApplicationService,
    private apiDataService: ApiDataService
  ) { }

  ngOnInit() {
    this.application = this.applicationService.getApplication();

    this.allSameMerchant = this.vouchers.every(voucher => {
      return voucher.merchantName === this.application.MerchantName;
    });

    if (this.allSameMerchant) {
      // If all the gc merchants are same look up if redemption details is avialable
      this.apiDataService.getVoucherRedemptionDetails(this.application.MerchantName).subscribe(
        redeemDetails => {
          this.redeemSteps = redeemDetails.content;
        },
        error => {
          this.showMerchantLogo = true;
        }
      );
    }
  }
}
